import { EventEmitterInterface } from '@propertyfinder/pf-frontend-common/src/module/event/emitter.interface';

import { DataStore } from 'common/module/data/store';
import { MyAccountEmptyListTemplatePropsInterface } from 'common/module/my-account/empty-list/template-props.interface';
import { UserAuthenticationEvent } from 'common/module/user/authentication.event';
import { UserAuthenticationServiceInterface } from 'common/service/user-authentication/service.interface';

export class MyAccountEmptyListViewStore extends DataStore {
  /**
   * @inheritDoc
   */
  protected state: MyAccountEmptyListTemplatePropsInterface;

  /**
   * Constructor
   */
  constructor(
    eventEmitter: EventEmitterInterface,
    private userAuthenticationService: UserAuthenticationServiceInterface
  ) {
    super(eventEmitter);
  }

  /**
   * @inheritDoc
   */
  public observers(): void {
    this.userAuthenticationService
      .getEventEmitter()
      .addListener(UserAuthenticationEvent.signInSucceeded, this.onUserLoginStatusChanged);

    this.userAuthenticationService
      .getEventEmitter()
      .addListener(UserAuthenticationEvent.logOutSucceeded, this.onUserLoginStatusChanged);
  }

  /**
   * @inheritdoc
   */
  public destroy(): void {
    this.userAuthenticationService
      .getEventEmitter()
      .removeListener(UserAuthenticationEvent.signInSucceeded, this.onUserLoginStatusChanged);

    this.userAuthenticationService
      .getEventEmitter()
      .removeListener(UserAuthenticationEvent.logOutSucceeded, this.onUserLoginStatusChanged);
  }

  /**
   * @inheritDoc
   */
  public initialize(options: MyAccountEmptyListTemplatePropsInterface): void {
    this.state = options;
    this.setState(this.state);
    this.observers();
  }

  /**
   * @inheritDoc
   */
  public getState(): MyAccountEmptyListTemplatePropsInterface {
    return this.state;
  }

  /**
   * user login status handler
   */
  private onUserLoginStatusChanged = () => {
    this.updateUserLoginStatus();
  };

  /**
   * updates user login status
   */
  private updateUserLoginStatus = () => {
    const isUserLoggedIn = !!this.userAuthenticationService.getToken();

    this.setState({
      ...this.state,
      isUserLoggedIn,
    });
  };
}
